export interface CalendarDay {
  day: number;
  isOpen: boolean;
  content?: string;
  status: 'locked' | 'live' | 'past';
}

export interface Suggestion {
  id?: string;
  text: string;
  author: string;
  votes: number;
  createdAt: any; // Firestore Timestamp
}

export interface ProofItem {
  id: string;
  title: string;
  description: string;
  imageUrl?: string;
  date: string;
}

export enum Tab {
  ADVENT = 'ADVENT',
  PROOF = 'PROOF',
  SUGGESTIONS = 'SUGGESTIONS'
}